<template>
  <div class="margin-dock-page" :class="{ 'is-detail': detail }">
    <span class="margin-dock-page-title" :style="{fontSize:fontSize+'px'}">{{title}}</span>
    <span ref="measure" class="margin-dock-page-title dock-title-measure" aria-hidden="true">{{title}}</span>
  </div>
</template>
<script>
export default {
  name:'FittedMarginTitle',
  props:{title:String,detail:Boolean},
  data:()=>({fontSize:35}),
  watch:{title(){this.$nextTick(this.scheduleFit);},detail(){this.$nextTick(this.scheduleFit);}},
  mounted(){
    this._resize=new ResizeObserver(this.scheduleFit);
    this._resize.observe(this.$el);this._resize.observe(this.$refs.measure);
    document.fonts?.ready.then(this.scheduleFit);
    this.fit();
  },
  beforeUnmount(){
    this._resize?.disconnect();this._resize=null;
    cancelAnimationFrame(this._fitFrame);this._fitFrame=null;
  },
  methods:{
    scheduleFit(){
      if(!this._resize||this._fitFrame!=null)return;
      // Changing the font also changes the observed dock's intrinsic width.
      // Apply it outside ResizeObserver delivery, coalescing both size reports.
      this._fitFrame=requestAnimationFrame(()=>{this._fitFrame=null;this.fit();});
    },
    fit(){
      const available=this.$el.clientHeight,natural=this.$refs.measure.offsetHeight;
      if(available<=0||natural<=0)return;
      const size=Math.max(1,Math.min(35,Math.floor(35*(available-2)/natural*100)/100));
      if(size!==this.fontSize)this.fontSize=size;
    },
  },
};
</script>
<style scoped>
.margin-dock-page{top:148px;display:flex;align-items:flex-end;}
.margin-dock-page-title{display:block;writing-mode:vertical-rl;text-orientation:sideways;transform:rotate(180deg);white-space:nowrap;font-family:-apple-system,BlinkMacSystemFont,'SF Pro Display','Segoe UI',sans-serif;font-weight:550;line-height:1.1;letter-spacing:.13em;text-transform:uppercase;}
.is-detail .margin-dock-page-title{letter-spacing:.055em;text-transform:none;}
.dock-title-measure{position:absolute;top:0;left:0;visibility:hidden;pointer-events:none;font-size:35px;height:max-content;}
</style>
